import React from 'react';
import { Link as LinkMaterial, LinkProps as MuiLinkProps } from '@mui/material';

interface LinkProps extends Omit<MuiLinkProps, 'onChange'> {
  href: string;
  onChange: (event: React.MouseEvent, page: string | null) => void;
  className?: string;
}

const Link: React.FC<LinkProps> = ({ href, onChange, className, ...props }) => {
  const url = new URL(window.location.origin + href);
  const params = new URLSearchParams(url.search);
  const page = params.get('page');

  return (
    <LinkMaterial
      {...props}
      className={className}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        onChange(e, page);
      }}
    />
  );
};

export default Link;
